module.exports = __webpack_public_path__ + "img/kverneland_ixter_b.0e0ecb76.jpg";